import {
  ApiClient,
  TriggerFlowRequest,
  TriggerFlowResponse,
  TriggerFlowOptions,
} from "@quotientjs/core"

export class Flow {
  private apiClient: ApiClient

  constructor(apiClient: ApiClient) {
    this.apiClient = apiClient
  }

  /**
   * Triggers a flow by its id.
   *
   * @param {TriggerFlowOptions} options - Options for triggering the flow
   * @returns {TriggerFlowResponse} Promise resolving to the flow data
   */
  async trigger(options: TriggerFlowOptions): Promise<TriggerFlowResponse> {
    const request = new TriggerFlowRequest(options)
    const response = await this.apiClient.call(request)
    return response
  }
}
